import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-full-1" }
const _hoisted_2 = { class: "form-field-floating reactive active my-5" }
const _hoisted_3 = {
  key: 0,
  class: "text-red"
}
const _hoisted_4 = { class: "form-field-floating reactive my-5" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = { class: "form-field-split my-5" }
const _hoisted_7 = { class: "form-field-floating reactive half" }
const _hoisted_8 = {
  key: 0,
  class: "text-red"
}
const _hoisted_9 = { class: "form-field-floating reactive half" }
const _hoisted_10 = {
  key: 0,
  class: "text-red"
}
const _hoisted_11 = { class: "form-field-split my-5" }
const _hoisted_12 = { class: "form-field-floating reactive half" }
const _hoisted_13 = {
  key: 0,
  class: "text-red"
}
const _hoisted_14 = { class: "form-field-floating reactive half" }
const _hoisted_15 = {
  key: 0,
  class: "text-red"
}
const _hoisted_16 = { class: "form-field-floating full my-5" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "text-red"
}
const _hoisted_19 = { class: "container-full-1" }
const _hoisted_20 = { class: "form-field-floating reactive active my-5" }
const _hoisted_21 = {
  key: 0,
  class: "text-red"
}
const _hoisted_22 = { class: "form-field-split active my-5" }
const _hoisted_23 = { class: "form-field-floating reactive half" }
const _hoisted_24 = {
  key: 0,
  class: "text-red"
}
const _hoisted_25 = { class: "form-field-floating reactive half" }
const _hoisted_26 = {
  key: 0,
  class: "text-red"
}
const _hoisted_27 = { class: "form-field-split active my-5" }
const _hoisted_28 = { class: "form-field-floating reactive half" }
const _hoisted_29 = {
  key: 0,
  class: "text-red"
}
const _hoisted_30 = { class: "form-field-floating reactive half" }
const _hoisted_31 = {
  key: 0,
  class: "text-red"
}
const _hoisted_32 = {
  key: 0,
  class: "text-red"
}

import { reactive, ref, watch, onMounted } from 'vue'
import moment from 'moment'

interface Collectivite {
  id: number
  nom: string
}

interface PersonalInfosPayload {
  nom: string | null
  prenom: string | null
  date_naissance: string | null
  age: number
  date_engagement: string | null
  anciennete: number
  collectivite_id: number | null
  salaire: string
  quotite_cessible_pourcent: string
  quotite_cessible_montant: string
  telephone: string | null
  email: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingPersonalInfosForm',
  props: {
    collectivites: {},
    defaultCollectiviteId: {}
  },
  emits: ["saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const formData = reactive<PersonalInfosPayload>({
  nom: '',
  prenom: '',
  date_naissance: '',
  age: 0,
  date_engagement: '',
  anciennete: 0,
  collectivite_id: null,
  salaire: '',
  quotite_cessible_pourcent: '',
  quotite_cessible_montant: '',
  telephone: '',
  email: ''
})

const emit = __emit

const errorMessage = ref('')
const loading = ref(false)
const isFormValid = ref(false)

const errors = reactive<Record<string, string>>({
  nom: '',
  prenom: '',
  date_naissance: '',
  age: '',
  date_engagement: '',
  anciennete: '',
  collectivite_id: '',
  salaire: '',
  quotite_cessible_pourcent: '',
  quotite_cessible_montant: '',
  telephone: '',
  email: ''
})

watch(
  () => formData.date_naissance,
  value => {
    if (!value) {
      formData.age = 0
      return
    }
    const birthDate = moment(value)
    if (birthDate.isValid()) {
      formData.age = moment().diff(birthDate, 'years')
    }
  }
)

watch(
  () => formData.date_engagement,
  value => {
    if (!value) {
      formData.anciennete = 0
      return
    }
    const engagementDate = moment(value)
    if (engagementDate.isValid()) {
      formData.anciennete = moment().diff(engagementDate, 'years')
    }
  }
)

// Pré-sélectionner la collectivité si fournie
onMounted(() => {
  if (props.defaultCollectiviteId && !formData.collectivite_id) {
    // Vérifier que la collectivité existe dans la liste
    const collectiviteExists = props.collectivites.some(c => c.id === props.defaultCollectiviteId)
    if (collectiviteExists) {
      formData.collectivite_id = props.defaultCollectiviteId
    }
  }
})

// Écouter les changements de la prop defaultCollectiviteId
watch(
  () => props.defaultCollectiviteId,
  (newValue) => {
    if (newValue && !formData.collectivite_id) {
      const collectiviteExists = props.collectivites.some(c => c.id === newValue)
      if (collectiviteExists) {
        formData.collectivite_id = newValue
      }
    }
  }
)

function validate() {
  let isValid = true
  Object.keys(errors).forEach(key => {
    errors[key] = ''
  })

  if (!formData.nom) {
    errors.nom = 'Le nom est requis'
    isValid = false
  }
  if (!formData.prenom) {
    errors.prenom = 'Le prénom est requis'
    isValid = false
  }
  if (!formData.date_naissance) {
    errors.date_naissance = 'La date de naissance est requise'
    isValid = false
  } else if (!moment(formData.date_naissance).isValid()) {
    errors.date_naissance = 'Le format de la date de naissance est invalide'
    isValid = false
  }
  if (!formData.age || isNaN(formData.age) || formData.age <= 0) {
    errors.age = "L'âge est requis"
    isValid = false
  }
  if (!formData.date_engagement) {
    errors.date_engagement = "La date d'engagement est requise"
    isValid = false
  } else if (!moment(formData.date_engagement).isValid()) {
    errors.date_engagement = "Le format de la date d'engagement est invalide"
    isValid = false
  }
  if (formData.anciennete === null || formData.anciennete < 0 || isNaN(formData.anciennete)) {
    errors.anciennete = "L'ancienneté est requise"
    isValid = false
  }
  if (!formData.collectivite_id) {
    errors.collectivite_id = 'La collectivité est requise'
    isValid = false
  }
  // Nettoyer le salaire pour la validation (retirer espaces et virgules)
  const salaireCleaned = formData.salaire.replace(/\s/g, '').replace(/,/g, '')
  const salaireValue = parseFloat(salaireCleaned)
  if (!formData.salaire || isNaN(salaireValue) || salaireValue <= 0) {
    errors.salaire = 'Le salaire est requis'
    isValid = false
  }
  
  // Nettoyer la quotité pour la validation (retirer espaces et virgules)
  const quotiteCleaned = formData.quotite_cessible_pourcent.replace(/\s/g, '').replace(/,/g, '')
  const quotitePourcent = parseFloat(quotiteCleaned)
  if (
    !formData.quotite_cessible_pourcent ||
    isNaN(quotitePourcent) ||
    quotitePourcent <= 0 ||
    quotitePourcent > 100
  ) {
    errors.quotite_cessible_pourcent = 'La quotité cessible en pourcentage est invalide (doit être entre 0 et 100)'
    isValid = false
  }
  
  // Nettoyer le montant pour la validation (retirer espaces et virgules)
  const montantCleaned = formData.quotite_cessible_montant.replace(/\s/g, '').replace(/,/g, '')
  const montantValue = parseFloat(montantCleaned)
  if (
    !formData.quotite_cessible_montant ||
    isNaN(montantValue) ||
    montantValue <= 0
  ) {
    errors.quotite_cessible_montant = 'La quotité cessible en montant est invalide'
    isValid = false
  }
  if (!formData.telephone) {
    errors.telephone = 'Le téléphone est requis'
    isValid = false
  }
  if (!formData.email) {
    errors.email = "L'email est requis"
    isValid = false
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = "Le format de l'email est invalide"
    isValid = false
  }

  isFormValid.value = isValid
  return isValid
}

async function onSubmit() {
  if (!validate()) {
    return
  }
  
  // Nettoyer les valeurs avant l'envoi (retirer espaces et virgules)
  const cleanedData = {
    ...formData,
    salaire: formData.salaire.replace(/\s/g, '').replace(/,/g, ''),
    quotite_cessible_pourcent: formData.quotite_cessible_pourcent.replace(/\s/g, '').replace(/,/g, ''),
    quotite_cessible_montant: formData.quotite_cessible_montant.replace(/\s/g, '').replace(/,/g, '')
  }
  
  emit('saved', cleanedData)
}

function formatSalaireInput(event: Event) {
  const input = event.target as HTMLInputElement
  // Ne garder que les chiffres (bloquer tous les caractères non numériques)
  const value = input.value.replace(/[^\d]/g, '')
  // Mettre à jour la valeur dans le modèle ET dans l'input
  formData.salaire = value
  input.value = value
  calculateQuotiteCessible()
}

function formatQuotiteInput(event: Event) {
  const input = event.target as HTMLInputElement
  // Ne garder que les chiffres et un point/virgule pour les décimales
  let value = input.value.replace(/[^\d.,]/g, '')
  // Remplacer les virgules par des points
  value = value.replace(/,/g, '.')
  // Ne garder qu'un seul point
  const parts = value.split('.')
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('')
  }
  // Mettre à jour la valeur dans le modèle ET dans l'input
  formData.quotite_cessible_pourcent = value
  input.value = value
  calculateQuotiteCessibleValue()
}

function onQuotiteKeyPress(event: KeyboardEvent) {
  // Autoriser les chiffres, le point, la virgule, et les touches de contrôle (backspace, delete, etc.)
  const allowedKeys = /[0-9.,]/
  const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End']
  
  if (!allowedKeys.test(event.key) && !controlKeys.includes(event.key) && !event.ctrlKey && !event.metaKey) {
    event.preventDefault()
  }
}

function onQuotitePaste(event: ClipboardEvent) {
  event.preventDefault()
  const pasted = (event.clipboardData || (window as any).clipboardData).getData('text')
  // Ne garder que les chiffres, points et virgules
  let value = pasted.replace(/[^\d.,]/g, '')
  // Remplacer les virgules par des points
  value = value.replace(/,/g, '.')
  // Ne garder qu'un seul point
  const parts = value.split('.')
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('')
  }
  formData.quotite_cessible_pourcent = value
  calculateQuotiteCessibleValue()
}

function calculateQuotiteCessible() {
  if (formData.salaire && formData.quotite_cessible_pourcent) {
    calculateQuotiteCessibleValue()
  }
}

function calculateQuotiteCessibleValue() {
  if (formData.salaire && formData.quotite_cessible_pourcent) {
    // Nettoyer les espaces et virgules du salaire
    const salaire = parseFloat(formData.salaire.replace(/\s/g, '').replace(/,/g, ''))
    // Nettoyer la quotité (remplacer virgule par point)
    const quotiteCleaned = formData.quotite_cessible_pourcent.replace(/\s/g, '').replace(/,/g, '.')
    const quotite = parseFloat(quotiteCleaned)
    
    if (!isNaN(salaire) && !isNaN(quotite)) {
      const value = (salaire * quotite) / 100
      formData.quotite_cessible_montant = Math.round(value).toString()
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "s20 form",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
        _createElementVNode("img", {
          src: "/public/icons/icon-info-perso.svg",
          class: "size-base",
          alt: ""
        }),
        _createTextVNode(" Informations personnelles ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
          name: "nom",
          id: "nom",
          placeholder: ""
        }, null, 512), [
          [_vModelText, formData.nom]
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("label", { for: "nom" }, [
          _createTextVNode("Nom "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1)),
        (errors.nom)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(errors.nom), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.prenom) = $event)),
          name: "prenom",
          id: "prenom",
          placeholder: ""
        }, null, 512), [
          [_vModelText, formData.prenom]
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("label", { for: "prenom" }, [
          _createTextVNode("Prénoms "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1)),
        (errors.prenom)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors.prenom), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.date_naissance) = $event)),
            name: "date_naissance",
            id: "date_naissance",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.date_naissance]
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("label", { for: "date_naissance" }, [
            _createTextVNode("Date de naissance "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          (errors.date_naissance)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors.date_naissance), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.age) = $event)),
            name: "age",
            id: "age",
            placeholder: "",
            readonly: ""
          }, null, 512), [
            [_vModelText, formData.age]
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("label", { for: "age" }, [
            _createTextVNode("Age "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          (errors.age)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errors.age), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.date_engagement) = $event)),
            name: "date_engagement",
            id: "date_engagement",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.date_engagement]
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("label", { for: "date_engagement" }, [
            _createTextVNode("Date d'engagement "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          (errors.date_engagement)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors.date_engagement), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.anciennete) = $event)),
            name: "anciennete",
            id: "anciennete",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.anciennete]
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("label", { for: "anciennete" }, [
            _createTextVNode("Ancienneté "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          (errors.anciennete)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errors.anciennete), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("select", {
          class: "form-input-select",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.collectivite_id) = $event)),
          name: "collectivite_id",
          id: "collectivite_id"
        }, [
          _cache[22] || (_cache[22] = _createElementVNode("option", { value: null }, "Sélectionnez votre collectivité", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.collectivites, (collectivite) => {
            return (_openBlock(), _createElementBlock("option", {
              value: collectivite.id,
              key: collectivite.id
            }, _toDisplayString(collectivite.nom), 9, _hoisted_17))
          }), 128))
        ], 512), [
          [_vModelSelect, formData.collectivite_id]
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("label", { for: "collectivite_id" }, [
          _createTextVNode("Votre collectivité "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1)),
        (errors.collectivite_id)
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors.collectivite_id), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_19, [
      _cache[36] || (_cache[36] = _createElementVNode("h3", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
        _createElementVNode("img", {
          src: "/public/icons/icon-engagement.svg",
          class: "size-base",
          alt: ""
        }),
        _createTextVNode(" Engagement ")
      ], -1)),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.salaire) = $event)),
          name: "salaire",
          id: "salaire",
          onInput: formatSalaireInput,
          onKeypress: _cache[8] || (_cache[8] = (e) => { if (!/[0-9]/.test(e.key)) e.preventDefault() }),
          onPaste: _cache[9] || (_cache[9] = (e) => { e.preventDefault(); const pasted = (e.clipboardData || (_ctx.window as any).clipboardData).getData('text'); const numbers = pasted.replace(/[^\d]/g, ''); formData.salaire = numbers; calculateQuotiteCessible(); }),
          placeholder: ""
        }, null, 544), [
          [_vModelText, formData.salaire]
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("label", { for: "salaire" }, [
          _createTextVNode("Salaire brut "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1)),
        _cache[26] || (_cache[26] = _createElementVNode("span", null, "F CFA", -1)),
        (errors.salaire)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(errors.salaire), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.quotite_cessible_pourcent) = $event)),
            name: "quotite_cessible_pourcent",
            id: "quotite_cessible_pourcent",
            onInput: formatQuotiteInput,
            onKeypress: onQuotiteKeyPress,
            onPaste: onQuotitePaste,
            placeholder: ""
          }, null, 544), [
            [_vModelText, formData.quotite_cessible_pourcent]
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("label", { for: "quotite_cessible_pourcent" }, [
            _createTextVNode("Quotité cessible max "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _cache[28] || (_cache[28] = _createElementVNode("span", null, "%", -1)),
          (errors.quotite_cessible_pourcent)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(errors.quotite_cessible_pourcent), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_25, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.quotite_cessible_montant) = $event)),
            name: "quotite_cessible_montant",
            id: "quotite_cessible_montant",
            placeholder: "",
            readonly: ""
          }, null, 512), [
            [_vModelText, formData.quotite_cessible_montant]
          ]),
          _cache[29] || (_cache[29] = _createElementVNode("label", { for: "quotite_cessible_montant" }, [
            _createTextVNode("Valeur "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _cache[30] || (_cache[30] = _createElementVNode("span", null, "F CFA", -1)),
          (errors.quotite_cessible_montant)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(errors.quotite_cessible_montant), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.telephone) = $event)),
            name: "telephone",
            id: "telephone",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.telephone]
          ]),
          _cache[32] || (_cache[32] = _createElementVNode("label", { for: "telephone" }, [
            _createTextVNode("Numéro de téléphone "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          (errors.telephone)
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(errors.telephone), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[34] || (_cache[34] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.email) = $event)),
            name: "email",
            id: "email",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.email]
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("label", { for: "email" }, [
            _createTextVNode("Adresse Email "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          (errors.email)
            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(errors.email), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn flex-center mt-8 mb-7",
        onClick: onSubmit
      }, [...(_cache[35] || (_cache[35] = [
        _createElementVNode("span", null, "Suivant", -1),
        _createElementVNode("img", {
          src: "/public/icons/icon-go.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1)
      ]))]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true)
    ])
  ], 32))
}
}

})